import Accordion from 'components/accordion/Accordion';
import Icon from 'components/icon/Icon';
import Link from 'components/link/Link';

import { ITabsMobile } from 'source/NFR.types';

const TabsMobile: React.FC<ITabsMobile> = ({ title, tabs, accordion }) => {
  if (!(tabs && tabs.length && tabs[0])) return null;
  const activeItem = tabs.find(tab => tab.isActive);

  return (
    <Accordion {...accordion} animate={false}>
      {({ Collapse, isOpen, toggle }) => (
        <div className="tabs-mobile">
          {!isOpen && (
            <label className="tabs-mobile--label" htmlFor="selector-button">
              {title}
            </label>
          )}
          <button id="selector-button" className="tabs-mobile--dropdown-button" onClick={toggle}>
            {activeItem ? activeItem.link.text : tabs[0].link.text}
            <Icon name="arrow-down" />
          </button>
          <Collapse className="tabs-mobile--collapse">
            <div className="tabs-mobile--dropdown">
              <h4 className="tabs-mobile--dropdown-title">{title}</h4>
              <ul className="tabs-mobile--dropdown-list">
                {tabs?.map(({ id, isActive, link }) => (
                  <li className="tabs-mobile--dropdown-item" key={id}>
                    <Link theme={!isActive ? 'black' : 'blue'} {...link} />
                  </li>
                ))}
              </ul>
            </div>
          </Collapse>
          {isOpen && <button className="tabs-mobile--overlay" onClick={toggle} />}
        </div>
      )}
    </Accordion>
  );
};

TabsMobile.displayName = 'TabsMobile';

export default TabsMobile;
